import { gql } from "@apollo/client";

export default gql`
  mutation UpdateSlackOrgSettingsMutation(
    $organizationId: Int!
    $indexMessages: Boolean
    $indexNewChannelsByDefault: Boolean
    $channelConfigurations: [SlackChannelConfigurationInput!]
  ) {
    updateSlackOrgSettings(
      organizationId: $organizationId
      indexMessages: $indexMessages
      indexNewChannelsByDefault: $indexNewChannelsByDefault
      channelConfigurations: $channelConfigurations
    ) {
      organization {
        id
        slackIndexingConfiguration {
          indexNewChannelsByDefault
          indexMessages
          channels {
            id
            name
            shouldIndex
          }
        }
        publicSlackChannels(first: 250) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;
